import { Navigate } from "react-router-dom";
import { useSessionExpiry } from "./auth/useSessionExpiry";
import { isUserLoggedIn } from "./modules/common/user/UserService";

export const ProtectedRoute = ({ children }: { children: any }) => {
  // logged-in pages: go to Session Expired as soon as the token expires
  useSessionExpiry();

  if (isUserLoggedIn()) {
    return children;
  } else
    return (
      <>
        <Navigate to="/" replace />
      </>
    );
};
